import { useSearchParams } from 'react-router-dom';
import { normalizeColor } from '../helpers/colors';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',

    bgVideo: searchParams.get('bgVideo') || '1',
    bgPoster: searchParams.get('bgPoster') || null,

    title: getDefaultValue(
      searchParams.get('title'),
      'Присылайте\\nсвои вопросы'
    ),

    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),

    cols: searchParams.get('cols') || 3,
    titleFontSize: searchParams.get('titleFontSize') || '4.4',
    sizeQR: searchParams.get('sizeQR') || '23',
    paddingQR: searchParams.get('paddingQR') || '0',
    authorFontSize: searchParams.get('authorFontSize') || '2.6',
    msgFontSize: searchParams.get('msgFontSize') || '3.125',

    // clrBgAdvt:
    //   normalizeColor(searchParams.get('clrBgAdvt')) || 'rgba(0,0,0,0.8)',
    // clrTextAdvt:
    //   normalizeColor(searchParams.get('clrTextAdvt')) || 'rgba(255,255,255,1)',
    // phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '4.8',
    // phoneNumber,
    // socials: searchParams.get('socials'),
  };
};
